
import { Component, Prop, Vue } from "vue-property-decorator";
import AppUserAvatar from "@/components/V2/AppUser/AppUserAvatar.vue";
import { SMUser } from "@/store";
import { chatwootShutdown } from "@/utils/chatwoot";

const ICONS = {
  chevronDown: "chevron-down",
  chevronUp: "chevron-up",
};

const LOCAL_STORAGE_KEY_CASE_ID = "case_id";
const LOGIN_PATH = "/auth/login";
const MY_ACCOUNT_ROUTE = "MyAccount";
const TEAMMATES_ROUTE = "Teammates";

@Component({
  components: {
    AppUserAvatar,
    NotificationsModule: () => import("@/modules/Notifications/components/NotificationsModule.vue"),
  },
})
export default class AppUser extends Vue {
  @Prop({ type: Boolean, default: true }) readonly showControls: boolean;

  get contextMenuProps() {
    return {
      theme: "context-menu",
      triggers: [],
      shown: this.open,
      placement: "bottom-end",
      distance: 8,
    };
  }

  get user() {
    return SMUser.user ?? null;
  }

  get name() {
    const { first_name, last_name } = this.user;

    if (!first_name) return "Unknown";

    let name = first_name;

    if (last_name) name += ` ${last_name}`;

    return name;
  }

  get firstName() {
    const { first_name } = this.user;

    if (!first_name) return "Unknown";

    return first_name;
  }

  get avatar() {
    const { user } = this;

    return user?.avatar ?? null;
  }

  icons = ICONS;

  get controlIcon() {
    return this.open ? ICONS.chevronUp : ICONS.chevronDown;
  }

  get classes() {
    // const { border, selected } = this;
    //
    // return {
    //   [`${CLASS}_border`]: border,
    //   [`${CLASS}_selected`]: selected,
    // };

    return {};
  }

  open = false;

  toggleMenu() {
    this.open = !this.open;
  }

  closeMenu() {
    this.open = false;
  }

  async goAccount() {
    try {
      await this.$router.push({
        name: MY_ACCOUNT_ROUTE,
      });
    } catch {
      return;
    }
  }

  async goTeammates() {
    try {
      await this.$router.push({
        name: TEAMMATES_ROUTE,
      });
    } catch {
      return;
    }
  }

  get showNotifications() {
    if (this.$route.fullPath.includes("notifications")) return false;

    return SMUser?.user?.ID && SMUser.isEmployer;
  }

  // isProduction = process.env.NODE_ENV === "production";
  isProduction = false;

  shutdownIntercom() {
    if (!this.isProduction) return;
    chatwootShutdown();
  }

  logout() {
    this.shutdownIntercom();

    localStorage.removeItem(LOCAL_STORAGE_KEY_CASE_ID);

    this.$auth.logout({ redirect: LOGIN_PATH });
  }

  get menuItems() {
    if (SMUser.isEmployer)
      return [
        {
          label: "Profile",
          icon: "user",
          method: this.goAccount,
        },
        {
          label: "Add teammates",
          icon: "user-plus",
          method: this.goTeammates,
        },
        {
          label: "Logout",
          icon: "logout",
          method: this.logout,
        },
      ];

    return [
      {
        label: "Logout",
        icon: "logout",
        method: this.logout,
      },
    ];
  }
}
